export const mapKeys = (obj, callback) => {
  const result = {}
  Object.entries(obj).forEach(([key, value]) => {
    // eslint-disable-next-line prefer-destructuring
    result[callback(value, key)] = value
  })
  return result
}

export function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64)
  const binaryLen = binaryString.length
  const bytes = new Uint8Array(binaryLen)

  for (let i = 0; i < binaryLen; i += 1) {
    const ascii = binaryString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
}
